import axios from "axios";

// Default values for all axios requests
axios.defaults.withCredentials = true;
axios.defaults.validateStatus = (status) => status < 300;
axios.defaults.timeout = 30 * 1000; // 10 seconds

/**
 * Fired when the API refuses a request because the account requires
 * two-factor authentication and this member has not set it up (errorCode
 * 10094). The enforcement gate listens and shows the enrolment takeover, so
 * a tab that was open when the owner turned the requirement on - or when the
 * grace period ran out - flips into it instead of failing quietly.
 */
export const MFA_LOCKED_EVENT = "encharge:mfa-locked";

axios.interceptors.response.use(undefined, (error) => {
  if (error?.response?.data?.error?.errorCode === 10094) {
    try {
      window.dispatchEvent(new CustomEvent(MFA_LOCKED_EVENT));
    } catch (e) {
      // a browser without CustomEvent still gets the rejected request
    }
  }
  return Promise.reject(error);
});
